/**
 * 所有接口变量都以 api开头，例如：apiGetUserInfo
 */
 import { apiPost } from 'utils'
 import { IAddEditRoleRequest, IMenuListRequest, IRoleItem, IRoleListRequest, ITreeItem } from 'model'
 import { IdList, PaginationResponse, XhhyResponse } from 'Xhhy-common/common'
  
  /**
   * 获取角色列表
   * @param params
   */
  export const apiRoleList = async (params: IRoleListRequest) => {
   return await apiPost<IRoleListRequest, PaginationResponse<IRoleItem>>(`/ticpocapi/role/list`, params)
  }
 
  /**
   * 新建角色
   * @param params
   */
   export const apiAddRole = async (params: IAddEditRoleRequest) => {
     return await apiPost<IAddEditRoleRequest, XhhyResponse>(`/ticpocapi/role/save`, params)
   }

   /**
   *  修改角色
   * @param params
   */
    export const apiEditRole = async (params: IAddEditRoleRequest) => {
      return await apiPost<IAddEditRoleRequest, XhhyResponse>(`/ticpocapi/role/update`, params)
    }
 
   /**
   * 删除角色
   * @param params
   */
    export const apiDeleteRole = async (params: IdList) => {
     return await apiPost<IdList, XhhyResponse>(`/ticpocapi/role/delete`, params)
   }

   /**
   * 获取菜单树
   * @param params
   */
    export const apiMenuList = async (params: IMenuListRequest) => {
      return await apiPost<IMenuListRequest, Array<ITreeItem>>(`/ticpocapi/menu/init`, params)
    }

 
  